<div class="padding flex column fix-height">
	<b class="margin-bottom-small">Upload {{data.single ? '' : 'multiple'}}</b>

	<b class="flex center"><mat-icon>help_outline</mat-icon> Renaming tip:</b>

	<div class="tip-section">
		Please rename your diles following this convetion:
		<br>
		<span>{{format}}</span>
		<br>
		Example: S000010---00136.5--_22_16-9.png
	</div>

	<input 
		type="file" 
		#fileInput 
		[multiple]="!data.single" 
		accept="image/*" 
		(change)="onFileSelected($event)"
		style="display: none;" 
	/>
	<button style="width: 25%;" class="flex between" (click)="fileInput.click()"><mat-icon>upload</mat-icon> Select files</button>

	@if(files.length === 0 ){
		<!-- (dragstart)="onDragStart($event)"
		(dragleave)="onDropZoneDragLeave($event)" -->
		<div class="drag-section"
		(dragover)="onDropZoneDragOver($event)"
		(drop)="onDropZoneDrop($event)"
		>
		<mat-icon>upload</mat-icon>
		Drag files here
	</div>
	}@else if ( files.length === 1 && data.single){
		<div class="preview-section">
			<img [src]="previewUrls[0]" alt="Preview" class="preview-image" />
			<span>{{ files[0].name }}</span>
		</div>
	} @else {
		
	}

	<div class="flex column end margin-top-small">
		<div class="flex center">
			<button class="stroked margin-right-small" (click)="onClose()">
				<mat-icon>undo</mat-icon>
				Discard
			</button>
			<button [mat-dialog-close]="files" cdkFocusInitial>
				<mat-icon>upload</mat-icon>
				Upload
			</button>
		</div>
	</div>
</div>
